import { AppRoutes } from 'constants/appRoutes';
import { USER_PROFILE_CONSTANT } from 'model/constants/actionConstants';
import { axiosInstanceV2 } from 'model/services/axiosProvider/client';
import { queryClient } from 'services/request';
import { removeAccount, setAuth, setListAccountUser, setTimeoutLogin } from 'functions';
import { getAllMenuByRoleAct } from './CategoryMenuAction';
// import { getMenuAct } from './LoginAction';

export const handleLoginSuccess = (data) => {
  return (dispatch) => {
    const listAccountUser = data.accounts;

    delete data.userImage;
    delete data.accounts;
    try {
      setListAccountUser(listAccountUser);
    } catch (error) {}

    removeAccount();
    setAuth(data);
    setTimeoutLogin();
    window.location.href = AppRoutes.home;
    // dispatch(getMenuAct());
    dispatch(getAllMenuByRoleAct(data?.roleMenus));
  };
};

const checkValidateForgotPassword = async (data) => {
  try {
    const res = await queryClient.post('user/forgotPasswordValid', data);
    return res?.data;
  } catch (error) {}
};

const forgotPassword = async (data) => {
  try {
    const res = await queryClient.post('user/forgotPassword', data);
    return res?.data;
  } catch (error) {}
};

const updateAvatar = async (data) => {
  try {
    const res = await axiosInstanceV2.post('user/updateAvatar', data);
    return res?.data;
  } catch (error) {}
};

const getUserProfile = (userCode) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: USER_PROFILE_CONSTANT.START_FETCHING,
      });
      const res = await axiosInstanceV2.get('user/searchUserInfo', {
        params: {
          userCode: userCode,
        },
      });
      const infoUser = res.data.data.userInfo;
      dispatch({
        type: USER_PROFILE_CONSTANT.SET_USER_PROFILE,
        payload: infoUser,
      });
      dispatch({
        type: USER_PROFILE_CONSTANT.STOP_FETCHING,
      });

      return res?.data;
    } catch (error) {
      dispatch({
        type: USER_PROFILE_CONSTANT.STOP_FETCHING,
      });
    }
  };
};

const resetAuth = () => {
  return async (dispatch) => {
    dispatch({
      type: USER_PROFILE_CONSTANT.RESET,
    });
  };
};

const updatePassword = async (data) => {
  console.log(data);
  try {
    const res = await queryClient.post('user/updatePassword', data);
    return res?.data;
  } catch (error) {}
};

const updateAgentNumber = async (data) => {
  try {
    const res = await queryClient.post('user/updateAgentNumber', data);
    return res?.data;
  } catch (error) {}
};

const searchAgentCode = async (data) => {
  try {
    const res = await queryClient.post('user/searchAgentCode', data);
    return res?.data;
  } catch (error) {}
};

const searchAgentInfo = async (data) => {
  try {
    const res = await queryClient.post('user/searchAgentInfo', data);
    return res?.data;
  } catch (error) {}
};

const searchAgentName = async (data) => {
  try {
    const res = await queryClient.post('user/searchAgentName', data);
    return res?.data;
  } catch (error) {}
};

const updateUserAlias = async (data) => {
  try {
    const res = await queryClient.post('user/updateUserAlias', data);
    return res?.data;
  } catch (error) {}
};

const deleteUser = async (data) => {
  try {
    const res = await queryClient.post('user/detele', data);
    return res?.data;
  } catch (error) {}
};

const authActions = {
  checkValidateForgotPassword,
  forgotPassword,
  updateAvatar,
  getUserProfile,
  resetAuth,
  updatePassword,
  updateAgentNumber,
  searchAgentCode,
  searchAgentInfo,
  searchAgentName,
  updateUserAlias,
  deleteUser,
};

export default authActions;
